module.exports = __webpack_public_path__ + "static/media/tigger_soundi_visoki_4.e8dfc578.mp3";